/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `critical` - Critical
 * * `high` - High
 * * `medium` - Medium
 * * `low` - Low
 * * `info` - Info
 * @export
 */
export const StealerLeakSeverityEnum = {
    Critical: 'critical',
    High: 'high',
    Medium: 'medium',
    Low: 'low',
    Info: 'info'
} as const;
export type StealerLeakSeverityEnum = typeof StealerLeakSeverityEnum[keyof typeof StealerLeakSeverityEnum];


export function instanceOfStealerLeakSeverityEnum(value: any): boolean {
    for (const key in StealerLeakSeverityEnum) {
        if (Object.prototype.hasOwnProperty.call(StealerLeakSeverityEnum, key)) {
            if (StealerLeakSeverityEnum[key as keyof typeof StealerLeakSeverityEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StealerLeakSeverityEnumFromJSON(json: any): StealerLeakSeverityEnum {
    return StealerLeakSeverityEnumFromJSONTyped(json, false);
}

export function StealerLeakSeverityEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): StealerLeakSeverityEnum {
    return json as StealerLeakSeverityEnum;
}

export function StealerLeakSeverityEnumToJSON(value?: StealerLeakSeverityEnum | null): any {
    return value as any;
}

export function StealerLeakSeverityEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): StealerLeakSeverityEnum {
    return value as StealerLeakSeverityEnum;
}

